// extracted by mini-css-extract-plugin
export default {"appcontents":"app_appcontents__tET2U","cardscontainer":"app_cardscontainer__1JzwY","formcontainer":"app_formcontainer__-V8KZ"};